<template>
  <div class="container px-4">
    <div class="tag-header">
      <div class="tag-title">
        <h1>{{ tag.name }}</h1>
      </div>
    </div>
    <div class="list-posts">
      <div class="tag-main">
        <div class="row p-0">
          <div class="col-md-4" v-for="post in posts" :key="post.id">
            <div class="tag-card">
              <img class="img-tag-list" v-if="post._embedded['wp:featuredmedia']"
              :src="post._embedded['wp:featuredmedia'][0].source_url">
              <div class="tag-info">
                <router-link :to="{ name: 'post', params: { postSlug: post.slug }}">
                  <h2 v-html="post.title.rendered"></h2>
                </router-link>
                <p>{{post._embedded.author[0].name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <pagination :pagination="pagination"
        @prev="--queryOptions.page; getPosts();"
        @next="queryOptions.page++; getPosts();">
      </pagination>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import Pagination from '../components/Pagination'

  export default {
    name: 'Tag',
    components: {
      Pagination,
    },
    data:() => {
      return {
        title: '',
        author: '',
        queryOptions: {
          per_page: 24,
          page: 1, // Current page of the collection.
          _embed: true,
        },
        tag: [],
        posts: [],
        pagination: {
                    prevPage: '',
                    nextPage: '',
                    totalPages: '',
                    from: '',
                    to: '',
                    total: '',
                },
      }
   },
   created () {
    this.getTag()
   },
   methods: {
    getTag () {
      var path = this.$route.path.split('/')
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/tags?slug=' + path[path.length - 1], {params: this.queryOptions})
      .then(response => {
        this.tag = response.data[0]

        if (this.tag === undefined) {
          this.$router.push({name: 'NotFound'})
        }

        document.title = this.tag.name
        this.getPosts()
      })
      .catch(e => {
        console.log(e)
      })
    },
    getPosts () {
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/posts?tags=' + this.tag.id, {params: this.queryOptions})
      .then(response => {
        this.posts = response.data
        this.configPagination(response.headers)
      })
      .catch(e => {
        console.log(e)
      })
    },
    configPagination (headers) {
      this.pagination.total = +headers['x-wp-total'];
      this.pagination.totalPages = +headers['x-wp-totalpages'];
      this.pagination.from = this.pagination.total ? ((this.queryOptions.page - 1) * this.queryOptions.per_page) + 1 : ' ';
      this.pagination.to = (this.queryOptions.page * this.queryOptions.per_page) > this.pagination.total ? this.pagination.total : this.queryOptions.page * this.queryOptions.per_page;
      this.pagination.prevPage = this.queryOptions.page > 1 ? this.queryOptions.page : '';
      this.pagination.nextPage = this.queryOptions.page < this.pagination.totalPages ? this.queryOptions.page + 1 : '';
    }
  },
}
</script>
<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}
.container {
  max-width: 1240px;
  min-height: 80vh;
  padding: 50px 0;
}
.tag-main,
.tag-grid {
  margin-top: 50px;
}
.tag-card {
  padding: 5px 0;
  margin: 10px 0;
  display: flex;
  font-family: 'Raleway', sans-serif;
  border-bottom: 1px solid #E5E5E5;
}
.tag-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tag-list i {
  color: #222;
  margin-left: 20px;
  cursor: pointer;
}
.tag-list i:hover,
.tag-list i:active {
  color: #999;
}
.tag-title h1 {
  font-family: 'Raleway', sans-serif;
  font-size: 24px;
  font-size: 400;
  text-transform: uppercase;
  letter-spacing: 2.4px;
}
.img-tag-list {
  width: 100px;
  height: 100px;
  object-fit: cover;
  object-position: center center;
}
.tag-info {
  margin-left: 10px;
}

.tag-info h2 {
  font-family: 'Raleway', sans-serif;
  font-size: 20px;
  font-weight: 500;
}
.tag-info p {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 700;
}
/* GRID */
.tag-grid-card {
  margin: 0;
  padding: 0;
}
.tag-grid-info h2 {
  font-family: 'Raleway', sans-serif;
  font-size: 20px;
  font-weight: 500;
  margin-top: 20px;
}
.tag-grid-info p {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin-top: 40px;
}
.tag-grid-card img {
  width: 100%;
}
.img-tag-grid {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center top;
}
.pagination-wrapper {
  text-align: center;
  margin: 0 auto;
}
</style>
